
import OrphanFlux from "@/pages/orphan/OrphanFlux.vue";
import OrphanDetails from "@/pages/orphan/OrphanDetails.vue";

export default [
  {
    path: '/orphan/:id',
    component: OrphanDetails,
    props: true
  },
  {
    path: '/orphan/',
    component: OrphanFlux,
    props: true
  },
]
